var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    id: "svg_1",
    stroke: "#F4F4FB",
    d: "m4,11.6603c-0.5942,-0.6664 -1.12234,-1.4674 -1.33766,-2.33388c-0.21532,-0.86649 -0.21646,-1.77237 -0.00332,-2.6394c0.21314,-0.86702 0.63415,-1.66913 1.22668,-2.33702c0.59252,-0.66789 1.33873,-1.1815 2.17418,-1.49645"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    id: "svg_2",
    stroke: "#F4F4FB",
    d: "m12.5029,4.84178c0.4147,0.59133 0.7089,1.25855 0.8658,1.96357c0.1569,0.70503 0.1734,1.43405 0.0485,2.14545c-0.1249,0.7114 -0.3886,1.3912 -0.7762,2.0007c-0.3876,0.6095 -0.8915,1.1366 -1.4828,1.5514"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.271d2319b7da150664095b979e0412fd.svg";
export { ForwardRef as ReactComponent };